module.exports = __webpack_public_path__ + "img/T1C_xh_12.f00b6fce.png";